import React, { Component } from 'react';

import { withStyles } from '@material-ui/core'
import {NavLink, withRouter} from 'react-router-dom';
import { drawerWidth } from '../config'
import Drawer from "@material-ui/core/Drawer/Drawer";
import classNames from "classnames";
import List from "@material-ui/core/List/List";
import mainRoutes from "../routes/mainRoutes";
import ListItem from "@material-ui/core/ListItem/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon/ListItemIcon";
import Icon from "@material-ui/core/Icon";
import ListItemText from "@material-ui/core/ListItemText/ListItemText";
import Collapse from "@material-ui/core/Collapse";
import {connect} from "react-redux";
import IconButton from "@material-ui/core/IconButton/IconButton";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import MenuIcon from "@material-ui/icons/Menu";
import {COLOR_text_base, COLOR_text_nav_selected} from "./CustomTheme/ThemeDefault/colors";

const styles = theme => ({
  drawerPaper: {
        background: '#ddd',
        position: 'relative',
        width: drawerWidth,
        marginTop: '49px',
        '&:hover': {
            background: '#4ddd37'

        }
  },
  anchor: {
    textDecoration: "none",
  },
    drawerOpen: {
        width: drawerWidth,

        //flexShrink: 1,
    },
    drawerClose: {
        overflowX: 'hidden',
        width: '3.6rem',
        '&:hover': {
            width: drawerWidth,
        }

    },
    drawerHide:{
        overflowX: 'hidden',
        width: '0px'
    },
    chevronIcon: {
        color: 'black'
    },
    navLink: {
        textDecoration: 'none',
        color: COLOR_text_base,
    },
    navLinkActive: {
        color: COLOR_text_nav_selected
    },
    navBarListItem: {
        height: 45
    },
    navBarListItemIcon: {
        height: '2.2em'
    }


});

class Sidebar extends Component {

    constructor(props){
        super(props);
        this.state = {
            openAvatar: false,
            openRaspa: (this.activeRoute("/raspa") !== '' ? true:false),
            openAutoclave: (this.activeRoute("/autoclave") !== '' ? true:false),

            drawerState: 1,
            open: true
        }
        this.activeRoute.bind(this);
        // this.minimizeSidebar = this.minimizeSidebar.bind(this);
        this.handleDrawer = this.handleDrawer.bind(this);
    }

    componentDidUpdate(prevProps: Readonly<P>, prevState: Readonly<S>, snapshot: SS): void {
        // if (this.props.drawerState !== this.state.drawerState){
        //     let op = (this.props.drawerState === 0)? false : true
        //     this.setState({drawerState: this.props.drawerState, open: op })
        // }
    }



    activeRoute(routeName) {
        return this.props.location.pathname.indexOf(routeName) > -1 ? 'active' : '';
    }

    handleDrawerClose = () => {
        this.setState({ open: false });
    };


    handleDrawer = () => {
        let drawerState = 0;
        switch(this.state.drawerState) {
            case 0:
                drawerState = 1;
                break;
            case 1:
                drawerState = 2;
                break;
            case 2:
                drawerState = 1;
                break;

        }
        let op = (drawerState === 0)? false : true
        this.setState({drawerState: drawerState, open:op});
    };



    render() {
    const { classes, open, auth, isAuthenticated } = this.props;
   // console.log('render sidebar', open);

      const ResetNavLink = ({...props}) => (
          <NavLink   className={classes.navLink}
                   activeClassName={classes.navLinkActive} {...props}>
          </NavLink>
      );

        const NavTitle = ({...props}) => {
            if (props.status) {
                return (<div className={classes.drawerHeader}>
                    <IconButton onClick={this.handleDrawer}>
                        <ChevronLeftIcon />
                    </IconButton>
                </div>)
            } else {
                return (<IconButton
                    color="inherit"
                    aria-label="Open drawer"
                    onClick={this.handleDrawer}
                    className={classNames({
                        [classes.hide]: false, //this.state.open,
                        [classes.removeRadius]: true,
                    })}
                >
                    <MenuIcon className={classes.removeRadius}/>
                </IconButton>)
            }
        }


    return (
        <Drawer
            variant="permanent"
            open={this.state.open}
            classes={{
                paper: classNames(classes.drawer, classes.drawerPaper, {
                    [classes.drawerOpen]: this.state.drawerState === 2,
                    [classes.drawerClose]: this.state.drawerState === 1,
                    [classes.drawerHide]: this.state.drawerState === 0,
                }),
            }}
            anchor="left"
        >
            <NavTitle status={this.state.open}/>
            {/*<Divider />*/}
            <List component="nav">



                {


                    mainRoutes.map((obj, index) => {
                        if (obj.type === 'noRoot') {
                            return null;
                        }
                        if (!isAuthenticated && obj.secgroup > 10) { return <React.Fragment key={index} /> }
                        if ( auth && auth.frontEndPermissions && obj.secgroup > 100 && !auth.frontEndPermissions.includes(obj.secgroup) )  { return <React.Fragment  key={index} /> }


                        ////////////////
                        if(obj.collapse){
                            var st = {};
                            st[obj["state"]] = !this.state[obj.state];
                            return (
                                <React.Fragment key={index}>

                                <ListItem  className={
                                    classNames({
                                        active : (this.props.location.pathname.indexOf(obj.path) > -1),
                                        navBarListItem : true
                                    })
                                    }
                                   onClick={ () => this.setState(st)}
                                   key={index}>
                                    {/*<a onClick={ () => this.setState(st)}  data-toggle="collapse" className={classes.navBarListItem}  aria-expanded={this.state[obj.state]}>*/}
                                        <ListItemIcon><Icon className={classes.navBarListItemIcon} style={obj.iconStyle}><img src={obj.svgIconFile}/></Icon></ListItemIcon>
                                        <ListItemText primary={obj.name}/>
                                    {/*</a>*/}
                                </ListItem>

                                    <Collapse in={this.state[obj.state]}>
                                        {
                                            obj.pages.map((prop, key) => {
                                                if (prop.redirect)
                                                    return null;
                                                if (prop.type === "noRoot")
                                                    return null;
                                                if (!isAuthenticated && obj.secgroup > 10) { return <React.Fragment key={index} /> }
                                                if ( auth && auth.frontEndPermissions && prop.secgroup > 100 && !auth.frontEndPermissions.includes(prop.secgroup) )  { return <React.Fragment  key={index} /> }




                                                if (prop.svgIconFile) {
                                                    return (<ResetNavLink key={prop.name+"-"+key} to={prop.path}>
                                                        <ListItem key={prop.name+"-"+index} button style={{paddingLeft:'80px'}} className={classes.navBarListItem}>
                                                            {/*<ListItemIcon>*/}
                                                            {/*  <Icon className={classes.navBarListItemIcon} style={prop.iconStyle}><img src={prop.svgIconFile}/></Icon></ListItemIcon>*/}
                                                            { (this.state.drawerState === 1 || this.state.drawerState === 2) &&
                                                            <ListItemText primary={prop.name}/>
                                                            }

                                                        </ListItem>
                                                    </ResetNavLink>);
                                                }

                                                if (prop.pngFile) {
                                                    return (<ResetNavLink key={key} to={prop.path}>
                                                        <ListItem key={prop.name+"-"+index} button style={{paddingLeft:'80px'}} className={classes.navBarListItem}>
                                                            <ListItemIcon><img style={prop.iconStyle} src={prop.pngFile}/></ListItemIcon>
                                                            {(this.state.drawerState === 1 || this.state.drawerState === 2) &&
                                                            <ListItemText primary={prop.name}/>
                                                            }

                                                        </ListItem>
                                                    </ResetNavLink>);
                                                }

                                                if (prop.icon) {
                                                    return (<ResetNavLink key={key} to={prop.path}>
                                                        <ListItem key={prop.name+"-"+index} button style={{paddingLeft:'80px'}} className={classes.navBarListItem}>
                                                            <ListItemIcon><Icon>{prop.icon}</Icon></ListItemIcon>
                                                            {(this.state.drawerState === 1 || this.state.drawerState === 2) &&
                                                            <ListItemText primary={prop.name}/>
                                                            }

                                                        </ListItem>
                                                    </ResetNavLink>);
                                                }


                                            })
                                        }
                                    </Collapse>
                                </React.Fragment>
                            );
                        }

                        ///////////////////////////////  icones
                        if (obj.svgIconFile) {
                            return (<ResetNavLink key={index} to={obj.path}>
                                <ListItem key={index} button className={classes.navBarListItem}>
                                    <ListItemIcon><Icon className={classes.navBarListItemIcon} style={obj.iconStyle}><img src={obj.svgIconFile}/></Icon></ListItemIcon>
                                    {(this.state.drawerState === 1 || this.state.drawerState === 2) &&
                                    <ListItemText primary={obj.name}/>
                                    }

                                </ListItem>
                            </ResetNavLink>);
                        }

                        if (obj.pngFile) {
                            return (<ResetNavLink key={index} to={obj.path}>
                                <ListItem key={index} button className={classes.navBarListItem}>
                                    <ListItemIcon><img style={obj.iconStyle} src={obj.pngFile}/></ListItemIcon>
                                    {(this.state.drawerState === 1 || this.state.drawerState === 2) &&
                                    <ListItemText primary={obj.name}/>
                                    }

                                </ListItem>
                            </ResetNavLink>);
                        }

                        if (obj.icon) {
                            return (<ResetNavLink key={index} to={obj.path}>
                                <ListItem key={index} button className={classes.navBarListItem}>
                                    <ListItemIcon><Icon>{obj.icon}</Icon></ListItemIcon>
                                    {(this.state.drawerState === 1 || this.state.drawerState === 2) &&
                                    <ListItemText primary={obj.name}/>
                                    }

                                </ListItem>
                            </ResetNavLink>);
                        }

                    })
                }
            </List>
        </Drawer>
    );


  }
}

const mapStateToProps = state => {
    return {
        isAuthenticated: state.auth.id !== null && (state.auth.expiresIn * 1000 > new Date().getTime()),
        auth: state.auth
    }
}

export default connect(mapStateToProps)(withRouter((withStyles(styles, {withTheme: true}))(Sidebar)));
